import { createSlice } from "@reduxjs/toolkit";

const initialRewardsTransactionState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  userLedgerSummary: [], 
  userRewardBalance: [], 
  approveRequest: [], 
  rejectRequest: [], 
  updatePlayedCount: [], 
  updateUserLedger: [], 
  companyDropdownList: [],
  getTokenData: {},
  relaodButtonLoading: false
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const RewardsTransactionSlice = createSlice({

  name: "rewardsTransaction",
  initialState: initialRewardsTransactionState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },

    rewardsTransactionList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    rewardsTransactionExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    usersLedgerReportSummary: (state, action) => {
      const { userLedgerSummary } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.userLedgerSummary = userLedgerSummary;
    },
    userRewardsBalanceLoader: (state, action) => {
      state.relaodButtonLoading = true;
    },
    userRewardsBalance: (state, action) => {
      const { userRewardBalance } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.relaodButtonLoading = false;
      state.userRewardBalance = userRewardBalance;
      state.getTokenData = userRewardBalance?.item?.tokenData;
    },
    userRewardsApproveRequest: (state, action) => {
      const { approveRequest } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.approveRequest = approveRequest;
    },
    userRewardsRejectRequest: (state, action) => {
      const { rejectRequest } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.rejectRequest = rejectRequest;
    },
    userRewardsUpdatePlayedCount: (state, action) => {
      const { updatePlayedCount } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.updatePlayedCount = updatePlayedCount;
    },
    userRewardsUpdateUserLedger: (state, action) => {
      const { updateUserLedger } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.updatePlayedCount = updateUserLedger;
    },
    CompanyDropdownList: (state, action) => {
      const { companyDropdownList } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      // state.totalCount = 0;
      state.companyDropdownList = companyDropdownList;
    },
    getTokenData: (state, action) => {
      const { tokenInfo } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      // state.totalCount = 0;
      state.getTokenData = tokenInfo;
    },
  }
});
